import { Button } from '@material-ui/core';

interface ConsultationNavigationProps {
  currentStep: number;
  canContinue: boolean;
  onBack?: () => void;
  onContinue?: () => void;
  continueText?: string;
  backText?: string;
  classes: {
    buttonContainer: string;
    baseButton: string;
    primaryButton: string;
    secondaryButton: string;
  };
  showBack?: boolean;
  isLoading?: boolean;
}

export const ConsultationNavigation = ({
  currentStep,
  canContinue,
  onBack,
  onContinue,
  continueText = 'Continuer',
  backText = 'Retour',
  classes,
  showBack = true,
  isLoading = false,
}: ConsultationNavigationProps) => {
  return (
    <div className={classes.buttonContainer}>
      {showBack && currentStep > 1 && (
        <Button 
          className={`${classes.baseButton} ${classes.secondaryButton}`}
          onClick={onBack}
          disabled={isLoading}
        >
          {backText}
        </Button>
      )}
      <Button 
        className={`${classes.baseButton} ${classes.primaryButton}`}
        onClick={onContinue}
        disabled={!canContinue || isLoading}
      >
        {isLoading ? 'Chargement...' : continueText}
      </Button>
    </div>
  );
};

export default ConsultationNavigation;
